var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15 29c7.732 0 14-6.268 14-14S22.732 1 15 1 1 7.268 1 15s6.268 14 14 14m4.818-18.454a4.545 4.545 0 1 1-9.09 0 4.545 4.545 0 0 1 9.09 0M8.022 23.242A6 6 0 0 1 8 22.727V22a6 6 0 0 1 6-6h2.545a6 6 0 0 1 6 6v.727q0 .26-.021.514A10.87 10.87 0 0 1 15.272 26a10.87 10.87 0 0 1-7.25-2.758",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;